import React, { useState } from 'react';
import '../OnboardingWizard.css';

const EmailVerificationStep = ({ 
  email, 
  clinicName, 
  onResend, 
  onBack, 
  isLoading, 
  error 
}) => {
  const [resendCooldown, setResendCooldown] = useState(0);
  const [resendSuccess, setResendSuccess] = useState(false);

  const handleResend = async () => {
    if (resendCooldown > 0) return;
    
    setResendSuccess(false);
    const result = await onResend();
    
    if (result && result.success) {
      setResendSuccess(true);
      setResendCooldown(60); // 60 second cooldown
      
      // Countdown timer
      const timer = setInterval(() => {
        setResendCooldown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  return (
    <div className="step-content">
      <div className="email-verification-content">
        {/* Email Icon */}
        <div className="verification-icon">
          <svg 
            width="80" 
            height="80" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1.5"
            className="email-icon"
          >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </div>

        {/* Main Message */}
        <div className="verification-message">
          <h2>Check Your Email</h2>
          <p className="verification-description">
            We've sent a verification link to <strong>{email}</strong>
          </p>
          <p className="verification-instruction">
            Click the link in the email to verify your account for{' '}
            <strong>{clinicName}</strong> and continue with plan selection.
          </p>
        </div>

        {/* Status Messages */}
        {resendSuccess && (
          <div className="alert alert-success">
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <polyline points="20,6 9,17 4,12" />
            </svg>
            Verification email sent successfully!
          </div>
        )}

        {error && (
          <div className="alert alert-error">
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
            {error}
          </div>
        )}

        {/* Email Instructions */}
        <div className="email-instructions">
          <h3>Can't find the email?</h3>
          <ul>
            <li>Check your spam or junk folder</li>
            <li>Make sure {email} is correct</li>
            <li>The verification link expires in 24 hours</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="verification-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onBack}
            disabled={isLoading}
          >
            ← Change Email
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={handleResend}
            disabled={isLoading || resendCooldown > 0}
          >
            {isLoading ? 'Sending...' : 
             resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 
             'Resend Email'}
          </button>
        </div>

        {/* Help Text */}
        <div className="verification-help">
          <p>
            <strong>Note:</strong> The verification link will take you directly to plan selection. 
            Keep this page open in case you need to resend the email.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationStep; 